export const dataSource = 'https://www.juliansalinas.ch'


// WEBPACK FOOTER //
// ./src/constants.js